var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "card card-primary" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "card-body" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-12" }, [
          _c("div", { staticClass: "form-group form-check" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.staff_q1,
                  expression: "form.staff_q1",
                },
              ],
              staticClass: "form-check-input",
              attrs: { id: "staff_q1", type: "checkbox" },
              domProps: {
                checked: Array.isArray(_vm.form.staff_q1)
                  ? _vm._i(_vm.form.staff_q1, null) > -1
                  : _vm.form.staff_q1,
              },
              on: {
                change: function ($event) {
                  var $$a = _vm.form.staff_q1,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 &&
                        _vm.$set(_vm.form, "staff_q1", $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        _vm.$set(
                          _vm.form,
                          "staff_q1",
                          $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                        )
                    }
                  } else {
                    _vm.$set(_vm.form, "staff_q1", $$c)
                  }
                },
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              { staticClass: "form-check-label", attrs: { for: "staff_q1" } },
              [
                _vm._v(
                  "\n                        Is your file in .csv or .xls format? (Note: .doc, .pages, or pdf files are not compatible)\n                    "
                ),
              ]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-12" }, [
          _c("div", { staticClass: "form-group form-check" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.staff_q2,
                  expression: "form.staff_q2",
                },
              ],
              staticClass: "form-check-input",
              attrs: { id: "staff_q2", type: "checkbox" },
              domProps: {
                checked: Array.isArray(_vm.form.staff_q2)
                  ? _vm._i(_vm.form.staff_q2, null) > -1
                  : _vm.form.staff_q2,
              },
              on: {
                change: function ($event) {
                  var $$a = _vm.form.staff_q2,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 &&
                        _vm.$set(_vm.form, "staff_q2", $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        _vm.$set(
                          _vm.form,
                          "staff_q2",
                          $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                        )
                    }
                  } else {
                    _vm.$set(_vm.form, "staff_q2", $$c)
                  }
                },
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              { staticClass: "form-check-label", attrs: { for: "staff_q2" } },
              [
                _vm._v(
                  "\n                        Are staff first names and last names in separate columns?\n                    "
                ),
              ]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-12" }, [
          _c("div", { staticClass: "form-group form-check" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.staff_q3,
                  expression: "form.staff_q3",
                },
              ],
              staticClass: "form-check-input",
              attrs: { id: "staff_q3", type: "checkbox" },
              domProps: {
                checked: Array.isArray(_vm.form.staff_q3)
                  ? _vm._i(_vm.form.staff_q3, null) > -1
                  : _vm.form.staff_q3,
              },
              on: {
                change: function ($event) {
                  var $$a = _vm.form.staff_q3,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 &&
                        _vm.$set(_vm.form, "staff_q3", $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        _vm.$set(
                          _vm.form,
                          "staff_q3",
                          $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                        )
                    }
                  } else {
                    _vm.$set(_vm.form, "staff_q3", $$c)
                  }
                },
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              { staticClass: "form-check-label", attrs: { for: "staff_q3" } },
              [
                _vm._v(
                  "\n                        Do all staff have a first AND last name?\n                    "
                ),
              ]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-12" }, [
          _c("div", { staticClass: "form-group form-check" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.staff_q4,
                  expression: "form.staff_q4",
                },
              ],
              staticClass: "form-check-input",
              attrs: { id: "staff_q4", type: "checkbox" },
              domProps: {
                checked: Array.isArray(_vm.form.staff_q4)
                  ? _vm._i(_vm.form.staff_q4, null) > -1
                  : _vm.form.staff_q4,
              },
              on: {
                change: function ($event) {
                  var $$a = _vm.form.staff_q4,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 &&
                        _vm.$set(_vm.form, "staff_q4", $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        _vm.$set(
                          _vm.form,
                          "staff_q4",
                          $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                        )
                    }
                  } else {
                    _vm.$set(_vm.form, "staff_q4", $$c)
                  }
                },
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              { staticClass: "form-check-label", attrs: { for: "staff_q4" } },
              [
                _vm._v(
                  "\n                        If you want us to email staff a link to their gallery, confirm staff roster includes email addresses.\n                    "
                ),
              ]
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h3", { staticClass: "card-title" }, [
        _vm._v("Staff Roster - Please click box to confirm"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }